import { useState } from "react";
import BasicProvider from "../services/basicProvider";
import { errorMsg } from "../utils/customFn";

const useApiRequest = () => {
  const [loading, setLoading] = useState(false);

  const fetchData = async (url, navigate, method = "GET", data = null, navigateTo) => {
    setLoading(true);
    try {
      const provider = new BasicProvider(url, navigate, true);
      const response =
        method === "GET"
          ? await provider.getRequest()
          : method === "POST"
            ? await provider.postRequest(data)
            : method === "PATCH"
              ? await provider.patchRequest(data)
              : null;


      if (response?.status) {
        return response.data;
      } else {
    
       
      }
    } catch (err) {
      errorMsg("An error occurred during the request.");
      // navigate(navigateTo);
      console.error("API Error:", err);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  return { loading, setLoading, fetchData };
};

export default useApiRequest;
